module.exports = __webpack_public_path__ + "img/logo_cotto.ee72afc5.jpeg";